<template>
    <div class="global-quicksearch-shortcut global-quicksearch-shortcut--illustrated" v-if="(shortcut.image && Object.keys(shortcut.image).length) || shortcut.icon">
        <div class="global-quicksearch-shortcut__image">
            <global-responsive-image v-if="shortcut.image && Object.keys(shortcut.image).length" :responsive-image="shortcut.image"/>
            <global-icon v-else-if="shortcut.icon" :icon="shortcut.icon"/>
        </div>
        <div class="global-quicksearch-shortcut__content">
            <h3 class="shortcut__header">{{ shortcut.headline }}</h3>
            <div class="shortcut__body" v-html="shortcut.bodytext"/>
        </div>
    </div>

    <div class="global-quicksearch-shortcut" v-else>
        <h3 class="shortcut__header">{{ shortcut.headline }}</h3>
        <div class="shortcut__body" v-html="shortcut.bodytext"/>
    </div>
</template>

<script>
import GlobalIcon from "@global/global-elements/global-icon/global-icon";
import GlobalResponsiveImage from "@global/global-elements/global-responsive-image/global-responsive-image";
export default {
    name: "global-quicksearch-shortcut",
    components: {GlobalResponsiveImage, GlobalIcon},
    props: ['shortcut']
}
</script>

